import '../../../webpack/node_modules/jquery-ui-dist/jquery-ui.min';
import '../../../webpack/node_modules/popper.js/dist/popper.min';
import '../../../webpack/node_modules/bootstrap/dist/js/bootstrap.min';
import selectBoxIt from '../../../webpack/node_modules/selectboxit/src/javascripts/jquery.selectBoxIt';
import * as lottie from '../../../webpack/node_modules/lottie-web/build/player/lottie';
import fancybox from '../../../webpack/node_modules/@fancyapps/fancybox/dist/jquery.fancybox.min';
import SmoothScroll from '../../../webpack/node_modules/smoothscroll-for-websites/SmoothScroll';
import AOS from '../../../webpack/node_modules/aos/dist/aos';
import swal from '../../../webpack/node_modules/sweetalert/dist/sweetalert.min';
import Waypoint from '../../../webpack/node_modules/waypoints/lib/jquery.waypoints.min';
console.log('javascript loaded');

var height = screen.height / 2;
var offsetScroll = 90;
var isMobile = false;

if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) isMobile = true;

if (isMobile) {

}

// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
let vh = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty('--vh', `${vh}px`);

// We listen to the resize event
window.addEventListener('resize', () => {
    // We execute the same script as before
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
});

$(document).ready(function() {
    console.log('jQuery ready');

    $(".introVideoHolder .sectionVideoPlay").on("click", playVideoSound);
    $(".introVideoHolder .sectionVideoSkip").on("click", initMain);

    setTimeout(function() {
        // *only* if we have anchor on the url
        if (window.location.hash) {
            // smooth scroll to the anchor id
            var _offset = 75;

            $('html, body').animate({
                scrollTop: ($(window.location.hash).offset().top - _offset) + 'px'
            }, 500, 'swing');
        }
    }, 1000);
    $(window).on("scroll", scrollFunction);
    $(window).resize(ResizeWindow);
    scrollFunction();
    replaceImgWithSVG();
    interactions();
    loading();


    // $("select").selectBoxIt({
    //     showFirstOption: false
    // });

    $('[data-fancybox]').fancybox();

    $(".fancybox-video").fancybox({
        'type': 'iframe',
        'overlayShow': true,
        'centerOnScroll': true,
        'speedIn': 100,
        'speedOut': 50,
        'width': 16 / 9 * height,
        'height': height,
        'autoDimensions': false
    });

    $(".accordion").accordion({
        heightStyle: "content",
        collapsible: true,
        active: false
    });

    SmoothScroll({
        stepSize: 100,
        animationTime: 500
    });


    $('#clock').downCount({
        date: '2/16/2023 23:59:59',
        offset: -5
    });

});

function initMain() {
    stopIntroVideo();
    $("body").removeClass('intro');
    setTimeout(function() {
        AOS.init();
        $("#home .renew[data-modal='Renew']").click();
    }, 1000);
    return false;
}

function ResizeWindow() {
    videoFullScreen();
}

function scrollFunction() {
    if ($(window).scrollTop() > 400) {
        $("body").removeClass('initial');
    } else {
        $("body").addClass('initial');
    }
}

function loading() {
    $("body").removeClass("loading");
    setTimeout(function() {
        playIntroVideo();
        //initMain();
    }, 1000);
}

/* Replace IMG with SVG */

function replaceImgWithSVG() {
    if (jQuery('img.svg').length > 0) {
        jQuery("img.svg").each(function() {
            var jQueryimg = jQuery(this).eq(0);
            var jQueryparent = jQueryimg.parent();
            var imgID = jQueryimg.attr('id');
            var imgClass = jQueryimg.attr('class');
            var imgURL = jQueryimg.attr('src');

            jQuery.ajax({
                url: imgURL,
                dataType: 'html',
                type: 'GET',
                success: function(_data) {
                    // Replace image with new SVG
                    jQueryimg.replaceWith(_data);
                    // Get the SVG tag, ignore the rest
                    var jQuerysvg = jQueryparent.find('svg');
                    // Add replaced image's ID to the new SVG
                    if (typeof imgID !== 'undefined') {
                        jQuerysvg = jQuerysvg.attr('id', imgID);
                    }
                    // Add replaced image's classes to the new SVG
                    if (typeof imgClass !== 'undefined') {
                        jQuerysvg = jQuerysvg.attr('class', imgClass);
                    }
                    // replaceImgWithSVG();
                }
            });
        });
    }
}

function interactions() {
    $(".navbar-nav a").on("click", onNavClick);
    $(".toggle-rightnav").on("click", openNav);
    $("#rightnav .close-btn").on("click", closeNav);
    $("#rightnav header .links a").on("click", toggleRightSubNav);
    $("#rightnav .mobile-nav .know-you").on("click", openKnowYou);
    $("#rightnav .mobile-nav .know-me").on("click", openRepInfo);
    $(".open-modal").on("click", openModal);
    $(".close-modal").on("click", closeModal);
    $("#f-stm").on("change", onSelectedSTM);
    $(".submit").on("click", submitProfile);

    function onNavClick() {
        if (!$(this).hasClass('active')) {
            var link = $(this).attr("data-id");
            $(".navbar-nav a").removeClass('active');
            $(this).addClass('active');
            var goTo = "#" + $('section[data-id="' + link + '"]').attr("id");
            $("body").addClass('linking');
            anchorScroll($(this), $(goTo), 400);
            closeNav();
            return false;
        }
    }

    function openNav() {
        $("body").addClass("modal-open");
        $("body > .overlay").fadeIn();
        $(".navbar-fixed-right").addClass("open");
        return false;
    }

    function closeNav() {
        if ($(window).width() < 1280 && $("#rightnav .mobile-nav").hasClass("hide")) {
            $("#rightnav .mobile-nav").removeClass("hide");
        } else {
            $("body").removeClass("modal-open");
            $(".navbar-fixed-right").removeClass("open");
            $("body > .overlay").fadeOut(0);
        }
        return false;
    }

    function openModal() {
        $(".modal").fadeOut();
        $("body").removeClass("animate-modal");
        var _modal = $(this).attr("data-modal");
        $("body").addClass("modal-open");
        $("body > .overlay").fadeIn();
        $(".modal[data-id='" + _modal + "']").fadeIn();
        setTimeout(function() {
            $("body").addClass("animate-modal");
        }, 10);
        return false;
    }

    function closeModal() {
        $("body").removeClass("modal-open animate-modal");
        $("body > .overlay").fadeOut();
        $(".modal").fadeOut();
        return false;
    }

    function toggleRightSubNav() {
        if (!$(this).hasClass("active")) {
            var _sub = $(this).attr("data-id");
            var _parent = $(this).parents().eq(3);
            $("#rightnav .links a, #rightnav > div").removeClass("active");
            _parent.find("*[data-id='" + _sub + "']").addClass("active");
        }
        return false;
    }

    function openKnowYou() {
        $("#rightnav .links a, #rightnav > div").removeClass("active");
        $("#rightnav *[data-id='know-you']").addClass("active");
        $("#rightnav .mobile-nav").addClass("hide");
        return false;
    }

    function openRepInfo() {
        $("#rightnav .links a, #rightnav > div").removeClass("active");
        $("#rightnav *[data-id='rep-info']").addClass("active");
        $("#rightnav .mobile-nav").addClass("hide");
        return false;
    }

    function onSelectedSTM() {
        var _selection = $(this).val();
        $("#rightnav .hidden").css("display", "none");
        $("#rightnav .hidden[data-id='" + _selection + "']").slideDown();
    }

    function onSubnavClick() {
        if (!$(this).hasClass("active")) {
            var _sub = $(this).attr("data-id");
            $("nav a, .calendar").removeClass("active");
            $("#event-calendar *[data-id='" + _sub + "']").addClass("active");
        }
        return false;
    }


    function submitProfile() {
        if ($(this).hasClass("disabled")) {
            return false;
        }

        var formVerified = true;
        var info = {};
        var errors = "";

        info.fullname = $(this).attr("data-name");
        info.account = $(this).attr("data-account");
        info.rep = $(this).attr("data-rep");
        info.purl = $(this).attr("data-purl");

        info.day = $("#f-day option:selected").val();
        info.month = $("#f-month option:selected").val();
        info.year = $("#f-year option:selected").val();
        info.player = $("#f-player").val();
        info.reason = $("#f-reason option:selected").val();
        info.stm = $("#f-stm option:selected").val();
        info.seatInterest = $("#seat-interest option:selected").val();

        info.stmName = $("#f-stm-name").val();
        info.stmEmail = $("#f-stm-email").val();
        info.stmPhone = $("#f-stm-number").val();
        
        info.birthday = info.month + "-" + info.day + "-" + info.year;

        if (info.day == "" || info.month == "" || info.year == "") {
            formVerified = false;
            errors += "You must enter a valid birthday. \n";
        }

        if (info.player == "") {
            formVerified = false;
            errors += "Stamps Player. \n";
        }

        if (info.reason == "") {
            formVerified = false;
            errors += "Reason for Tickets. \n";
        }

        if (info.stm == "Yes") {
            if (info.stmName == "") {
                formVerified = false;
                errors += "Contact Name \n";
            }
            if (info.stmEmail == "") {
                formVerified = false;
                errors += "Contact Email \n";
            }
            if (info.stmPhone == "") {
                formVerified = false;
                errors += "Contact Phone \n";
            }
        }

        if (info.seatInterest == "") {
            formVerified = false;
            errors += "Interest in adding 2023 seats. \n";
        }

        if (formVerified) {
            $.post("model/submitProfile.php", info, function(data) {
                var r = data + "";
                if (r == "success") {
                    swal("Success", "An email has been sent to your rep submitting your fan profile.", "success");
                    $(".submit").css("display", "none");
                } else {
                    sweetAlert("Server error. please try again", "error");
                }
            });
        } else {
            if ($("html").hasClass('ie8')) {
                alert("Please fill in the following " + errors);
            } else {
                swal("Error", errors, "error");
            }
        }
        return false;
    }
}

// Video Modal

function playIntroVideo() {
    $(".introVideoHolder").fadeIn();
    videoFullScreen();
    var video = $(".introVideoHolder video");
    video.get(0).currentTime = 0;
    video[0].play();
    video[0].muted = true;
    return false;
}

function stopIntroVideo() {
    var video = $(".introVideoHolder video");
    video.get(0).currentTime = 0;
    video[0].pause();
    video[0].muted = true;
    $(".introVideoHolder").fadeOut(1000);
    return false;
}

function playVideoSound() {
    var video = $(".introVideoHolder video");
    $(".introVideoHolder .overlay").fadeOut();
    video.get(0).currentTime = 0;
    video[0].muted = false;
    $(this).fadeOut();
    return false;
}


function videoFullScreen() {
    var winWidth = $(window).width();
    if (winWidth / $('.videoContainer').outerHeight() > 16 / 9) {
        $('.videoContainer video').css({
            'width': '100%',
            'height': 'auto',
        });
    } else {
        $('.videoContainer video').css({
            'width': 'auto',
            'height': '100%',
        });
    }
}

// Function to ease scroll on menu anchor clicks 
function anchorScroll(this_obj, that_obj, base_speed) {
    var this_offset = this_obj.offset();
    var that_offset = that_obj.offset();
    var offset_diff = Math.abs(that_offset.top - this_offset.top);

    var speed = (offset_diff * base_speed) / 1000;

    if (speed > 2000) {
        speed = 2000;
    }

    $("html,body").animate({
        scrollTop: that_offset.top - offsetScroll
    }, {
        duration: speed,
        easing: "easeInOutSine"
    }).promise().then(function() {
        $("body").removeClass('linking');
    });
}

// DownCount function takes date and offset variables. Only date is required to work. 
// Format should look like what's described below.
// DOM elements are listed below, but you can change it to whatever you want

$.fn.downCount = function(options, callback) {
    var settings = $.extend({
        date: null,
        offset: null
    }, options);

    // Throw error if date is not set
    if (!settings.date) {
        $.error('Date is not defined.');
    }

    // Throw error if date is set incorectly
    if (!Date.parse(settings.date)) {
        $.error('Incorrect date format, it should look like this, 12/24/2012 12:00:00.');
    }

    // Save container
    var container = this;

    /**
     * Change client's local date to match offset timezone
     * @return {Object} Fixed Date object.
     */
    var currentDate = function() {
        // get client's current date
        var date = new Date();

        // turn date to utc
        var utc = date.getTime() + (date.getTimezoneOffset() * 60000);

        // set new Date object
        var new_date = new Date(utc + (3600000 * settings.offset))

        return new_date;
    };

    /**
     * Main downCount function that calculates everything
     */
    function countdown() {
        var target_date = new Date(settings.date), // set target date
            current_date = currentDate(); // get fixed current date

        // difference of dates
        var difference = target_date - current_date;

        // if difference is negative than it's pass the target date
        if (difference < 0) {
            // stop timer
            clearInterval(interval);

            if (callback && typeof callback === 'function') callback();

            return;
        }

        // basic math variables
        var _second = 1000,
            _minute = _second * 60,
            _hour = _minute * 60,
            _day = _hour * 24;

        // calculate dates
        var days = Math.floor(difference / _day),
            hours = Math.floor((difference % _day) / _hour),
            minutes = Math.floor((difference % _hour) / _minute),
            seconds = Math.floor((difference % _minute) / _second);

        // fix dates so that it will show two digets
        days = (String(days).length >= 2) ? days : '0' + days;
        hours = (String(hours).length >= 2) ? hours : '0' + hours;
        minutes = (String(minutes).length >= 2) ? minutes : '0' + minutes;
        seconds = (String(seconds).length >= 2) ? seconds : '0' + seconds;

        // based on the date change the refrence wording
        var ref_days = (days === 1) ? 'Day' : 'Days',
            ref_hours = (hours === 1) ? 'Hour' : 'Hours',
            ref_minutes = (minutes === 1) ? 'Min' : 'Mins',
            ref_seconds = (seconds === 1) ? 'Sec' : 'Secs';

        // set to DOM
        container.find('#days').text(days);
        container.find('#hours').text(hours);
        container.find('#mins').text(minutes);
        container.find('#secs').text(seconds);

        container.find('#days-t').text(ref_days);
        container.find('#hrs-t').text(ref_hours);
        container.find('#mins-t').text(ref_minutes);
        container.find('#secs-t').text(ref_seconds);

        $(".days-left").text(days);
    };

    // start
    var interval = setInterval(countdown, 1000);
};